import Content from '../../content';

namespace('IO.Views.Packages', function (exports) {
  'use strict';

  var Show = Content.extend({
    dom: {
      SELECT2:
        '.select2select:not(#package-file-reference):not(#hierarchy-dropdown)',
      SELECTED_LEVEL_OF_HIERARCHY: '[name="package[hierarchy_field_id]"]',
      HIERARCHY_DROPDOWN: '#hierarchy-dropdown',
      STORES_DROPDOWN: '#stores-dropdown',
      DEVICES_DROPDOWN: '#devices-dropdown',
      TYPES_DROPDOWN: '#types-dropdown',
      SPINNER: '.spinner',
      PACKAGE_ID: '#package_id',
      PACKAGE_UPLOAD: '#package_upload_file',
      SELECTED_PACKAGE: '#package-file-reference',
      LOADER: '#progress-indicator',
      PACKAGE_STATUS: '#package-status',
      MODIFY_ACTIONS: '.io-form-action-edit, .io-form-action-delete',
      EDIT_BUTTON: '.io-form-action-edit',
      RJE_ACTIONS: '.io-form-action-rje',
      RJE_DOWNLOAD: '#rje-download',
      RJE_INSTALL: '#rje-install',
      PACKAGE_FORM: '.package-form',
      PACKAGE_CONTENTS: '#main-content',
      PACKAGE_CONTENT_FORM: '.custom.io-form',
      PACKAGE_SAVE_BUTTON: 'button.io-form-action-save',
      INSTALATION_DROPDOWN: '#installation',
      SCHEDULE_TO: '.DateTimeInputs input',
      SCHEDULE_TO_ROW: '.schedule-to-row',
      SCHEDULE_ERROR_DETAILS: '#schedule-error-details',
      SCHEDULE_DETAILS: '.schedule-details',
      SCHEDULE_WEEKDAY_SELECT2: '#schedule_weekday',
      SCHEDULE_ALL_WEEKDAYS_BUTTON: '#all-weekdays-button',
    },

    packageStatus: null,
    lastSelectedHierarchyLevel: null,
    lockReloadPaymentDevicesCallback: false,

    events: function () {
      var events = {};

      if ($(this.dom.HIERARCHY_DROPDOWN).length === 1) {
        events['change ' + this.dom.HIERARCHY_DROPDOWN] = '_reloadStores';
      }

      events['change ' + this.dom.STORES_DROPDOWN] = '_reloadPaymentDevices';
      events['click ' + this.dom.RJE_ACTIONS] = '_performRjeAction';
      events['click ' + this.dom.EDIT_BUTTON] =
        '_toggleScheduleFieldsAndPrepareHierarchyOptions';
      events['click ' + this.dom.SCHEDULE_ALL_WEEKDAYS_BUTTON] =
        '_scheduleAllWeekDays';
      events['submit ' + this.dom.PACKAGE_FORM] = '_checkStoreImpact';
      events['change ' + this.dom.INSTALATION_DROPDOWN] = '_toggleDevices';
      events['change ' + this.dom.SCHEDULE_TO] = '_scheduledToChanged';
      return events;
    },

    subscriptionId: null,

    _buildWebsocketChannel: function () {
      return '/package_' + $(this.dom.PACKAGE_ID).val();
    },

    _listen: function () {
      if (
        this.subscriptionId ||
        typeof $(this.dom.PACKAGE_ID).val() === 'undefined'
      ) {
        return;
      }

      this.subscriptionId = this._setStatus.bind(this);
      Messenger.on(this._buildWebsocketChannel(), this.subscriptionId);
    },

    _stopListening: function () {
      if (!this.subscriptionId) {
        return;
      }
      Messenger.off(this._buildWebsocketChannel(), this.subscriptionId);
      this.subscriptionId = null;
    },

    onDestroy: function () {
      this._stopListening();
    },

    render: function () {
      this.progressIndicator = $(this.dom.LOADER);
      this.scheduleDays = this.$el.find(this.dom.SCHEDULE_WEEKDAY_CHECKBOX);

      this.owners = {
        1: this.dom.STORES_DROPDOWN,
        2: this.dom.DEVICES_DROPDOWN,
        3: this.dom.TYPES_DROPDOWN,
      };

      this.dropdowns = this.$(this.dom.SELECT2);
      this.dropdowns.select2({ selectOnBlur: false });
      this._initializeHierarchyDropdown();
      this._listen();
      this._setStatus(InitialPackageStatus);
      this._prefillFields();
      this._handleS3Upload();
      this._setupUploadComponent();

      $(this.dom.SCHEDULE_WEEKDAY_SELECT2).select2({
        allowClear: true,
        placeholder: 'No recurring.',
      });
    },

    _initializeHierarchyDropdown: function () {
      var self = this;

      this.hierarchyDropdown = $(this.dom.HIERARCHY_DROPDOWN).select2({
        ajax: {
          url: '/' + currentCustomer + '/packages/hierarchy_fields',
          data: function (params) {
            var query = {
              q: params.term,
              page: params.page || 1,
            };

            return query;
          },
          processResults: function (data) {
            var ids = $(self.dom.HIERARCHY_DROPDOWN).val() || [],
              results = data.results,
              idItems;

            // Filter out available options based on the selected ones,
            // if the option is "included" on a selected ancestor.
            results = _.filter(results, function (item) {
              idItems = _.filter(item.ancestry.split('/'), function (ancestry) {
                return ids.indexOf(ancestry) > -1;
              });
              return idItems.length === 0;
            });

            return {
              results: results,
              pagination: data.pagination,
            };
          },
        },
      });
    },

    _matchCustom: function (params, data) {
      var searchText = $.trim(params.term).toLowerCase();

      if (data.disabled || data.text.toLowerCase().indexOf(searchText) < 0) {
        return null;
      }

      return data;
    },

    _setupUploadComponent: function () {
      var self = this,
        oldValue = $(this.dom.SELECTED_PACKAGE).val(),
        previousUploadOptions = '',
        updateOptions,
        initSelect;

      $(this.dom.SELECTED_PACKAGE)
        .find('option')
        .each(function (i, item) {
          if ($(item).val() !== '') {
            previousUploadOptions += $(item)[0].outerHTML;
          }
        });

      updateOptions = function (newOption, blank) {
        var options,
          previousValue = $(self.dom.SELECTED_PACKAGE).val();

        if (blank) {
          newOption = '<option value=""></option>' + newOption;
        }
        options = newOption + previousUploadOptions;
        $(self.dom.SELECTED_PACKAGE).html(options);
        initSelect();
        $(self.dom.SELECTED_PACKAGE).val(previousValue);
      };

      initSelect = function () {
        $(self.dom.SELECTED_PACKAGE).select2({
          placeholder: 'Select or Upload a file',
          formatResult: function (file) {
            if (file.id !== 'upload-new') {
              return file.text;
            }
            return $('<div class="select-file">' + file.text + '</div>');
          },
        });
      };

      $(this.dom.SELECTED_PACKAGE).on('select2:open', function () {
        if ($(this).val() !== '' && $(this).val() !== 'upload-new') {
          oldValue = $(this).val();
        }
      });

      initSelect();
      updateOptions(
        '<option value="upload-new">Click to upload a new file</option>',
        true,
      );

      $(this.dom.SELECTED_PACKAGE).change(function () {
        var val = $(this).val();

        if (val === 'upload-new') {
          $(self.dom.PACKAGE_UPLOAD).trigger('click');
          $(self.dom.SELECTED_PACKAGE).val(oldValue).change();
        }
      });

      $(self.dom.PACKAGE_UPLOAD).on('change', function () {
        var fileArr = $(this).val().split('\\'),
          selectedFile = 'Selected file: ' + fileArr[fileArr.length - 1],
          options;

        if (fileArr.join(',') !== '') {
          options =
            '<option value="selected-file">' + selectedFile + '</option>';
          updateOptions(
            '<option value="upload-new">Click to upload a new file</option>' +
              options,
            true,
          );
        }
        $(self.dom.SELECTED_PACKAGE).val('selected-file').trigger('change');
      });
    },

    _toggleScheduleFieldsAndPrepareHierarchyOptions: function () {
      $(this.dom.SCHEDULE_TO_ROW).removeClass('hidden');
      this._toggleScheduleDetails();
      this.lastSelectedHierarchyLevel = $(this.dom.HIERARCHY_DROPDOWN).val();
      this._updateHierarchyOptions();
    },

    _scheduleAllWeekDays: function () {
      $(this.dom.SCHEDULE_WEEKDAY_SELECT2)
        .val([0, 1, 2, 3, 4, 5, 6])
        .trigger('change');
    },

    _toggleScheduleDetails: function () {
      var scheduleDate = $(this.dom.SCHEDULE_TO),
        scheduleDetails = $(this.dom.SCHEDULE_DETAILS);

      if ($.isEmptyObject(scheduleDate.val())) {
        scheduleDetails.addClass('hidden');
      } else {
        scheduleDetails.removeClass('hidden');
      }
    },

    _scheduledToChanged: function () {
      this._toggleScheduleDetails();
    },

    _handleS3Upload: function () {
      this.S3Handler = new S3Handler({
        saveBtn: this.dom.PACKAGE_SAVE_BUTTON,
        fileTag: this.dom.PACKAGE_UPLOAD,
        errorContent: this.dom.PACKAGE_CONTENTS,
        contentForm: this.dom.PACKAGE_CONTENT_FORM,
        uploadPackage: this.dom.PACKAGE_UPLOAD,
        previousSelectedPackage: this.dom.SELECTED_PACKAGE,
        triggerOnSave: false,
      });
      this.S3Handler.startMonitoring();
    },

    _reloadStores: function (e, programmaticChange) {
      if (programmaticChange) {
        return;
      }

      this._updateHierarchyOptions();
    },

    _updateHierarchyOptions: function () {
      var $select = $(this.dom.HIERARCHY_DROPDOWN),
        data = $select.select2('data'),
        ids = [],
        filtered,
        filteredIds = [],
        idItems,
        ancestry,
        i,
        x;

      for (i in data) {
        ids.push(data[i].id);
      }

      // If an hierarchy item added is of an ancestor of another already selected,
      // the descendent is removed, because it is "included" in the ancestor.
      filtered = _.filter(data, function (item) {
        ancestry =
          typeof item.ancestry !== 'undefined'
            ? item.ancestry
            : item.element.dataset.ancestry;
        idItems = _.filter(ancestry.split('/'), function (ancestor) {
          return ids.indexOf(ancestor) > -1;
        });
        return idItems.length === 0;
      });

      for (x in filtered) {
        filteredIds.push(filtered[x].id);
      }

      if (filteredIds.length < ids.length) {
        $select.val(filteredIds).trigger('change');
      }
      this._reloadPaymentDevices();
    },

    _reloadPaymentDevices: function () {
      var self = this;

      if (this.lockReloadPaymentDevicesCallback) {
        return;
      }

      this._showLoader();
      this.dropdowns.attr('disabled', 'disabled');

      this.lockReloadPaymentDevicesCallback = true;
      $.ajax({
        url: '/' + currentCustomer + '/packages/available_resources',
        data: {
          store_ids: $(self.dom.STORES_DROPDOWN).val() || [], // eslint-disable-line camelcase
          hierarchy_field_ids: $(this.dom.HIERARCHY_DROPDOWN).val(), // eslint-disable-line camelcase
        },
      })
        .done(function (data) {
          self._populateDropdown($(self.dom.STORES_DROPDOWN), data.stores);
          self._populateDropdown(
            $(self.dom.DEVICES_DROPDOWN),
            data.payment_devices,
          );
          self._populateDropdown(
            $(self.dom.TYPES_DROPDOWN),
            data.payment_device_types,
          );
        })
        .fail(function () {
          alert(
            'An error occurred while fetching data. Please try selecting a Store again.',
          );
          self._populateDropdown($(self.dom.STORES_DROPDOWN), '');
          self._populateDropdown($(self.dom.DEVICES_DROPDOWN), '');
          self._populateDropdown($(self.dom.TYPES_DROPDOWN), '');
        })
        .always(function () {
          self.dropdowns.prop('disabled', false);
          self._hideLoader();
          self.lockReloadPaymentDevicesCallback = false;
        });
    },

    _populateDropdown: function (target, data) {
      var previousValues = target.val();

      target = $(target);
      target.select2().html(data);
      target.select2().val(previousValues);
      target.select2({ selectOnBlur: false }).trigger('change');
    },

    _disableAndClean: function (el) {
      $(el).val('').trigger('change');
      $(el).closest('tr').addClass('hidden');
    },

    _toggleDevices: function (e) {
      var val = $(e.target).val();

      if (val === 'pd') {
        this._disableAndClean(this.dom.TYPES_DROPDOWN);
        $(this.dom.DEVICES_DROPDOWN).closest('tr').removeClass('hidden');
      } else if (val === 'pdt') {
        this._disableAndClean(this.dom.DEVICES_DROPDOWN);
        $(this.dom.TYPES_DROPDOWN).closest('tr').removeClass('hidden');
      } else {
        this._disableAndClean(this.dom.DEVICES_DROPDOWN);
        this._disableAndClean(this.dom.TYPES_DROPDOWN);
      }
    },

    _hideLoader: function () {
      this.progressIndicator.removeClass('visible');
    },

    _showLoader: function () {
      this.progressIndicator.addClass('visible');
    },

    _prefillFields: function () {
      var parsedParams = this._parseUrlParams(),
        ownerDropdown,
        currentOwnerDropdownValue;

      if (parsedParams.specific === 'true') {
        ownerDropdown = this.$(this.owners[parsedParams.owner_type]);
        currentOwnerDropdownValue = ownerDropdown.val() || [];

        currentOwnerDropdownValue.push(parsedParams.owner_id);
        ownerDropdown
          .val(currentOwnerDropdownValue)
          .trigger('change')
          .closest('tr')
          .hide(0);

        this.dropdowns
          .not(ownerDropdown)
          .attr('disabled', 'disabled')
          .closest('tr')
          .hide(0);
      }
    },

    _parseUrlParams: function () {
      var urlParams = location.search.substr(1).split('&'),
        parsedParams = {},
        i,
        params;

      for (i = urlParams.length - 1; i >= 0; i--) {
        params = urlParams[i].split('=');
        parsedParams[params[0]] = params[1];
      }

      return parsedParams;
    },

    _setStatus: function (data) {
      this.packageStatus = data;
      if (
        this.packageStatus.package.status !== data.package.status ||
        this.packageStatus.logs.length < data.logs.length
      ) {
        this._updateScheduleErrors();
      }

      $(this.dom.PACKAGE_STATUS).text(this.packageStatus.message);
      $(this.dom.RJE_ACTIONS).attr('disabled', true).addClass('disabled');

      switch (
        this.packageStatus.package.status // eslint-disable-line default-case
      ) {
        case 'upload_completed':
          $(this.dom.RJE_DOWNLOAD)
            .prop('disabled', false)
            .removeClass('disabled');
          $(this.dom.RJE_DOWNLOAD).html(
            '<i class="icon cloud download"></i> Download',
          );
          break;
        case 'download_failed':
          $(this.dom.RJE_DOWNLOAD)
            .prop('disabled', false)
            .removeClass('disabled');
          $(this.dom.RJE_DOWNLOAD).html(
            '<i class="icon repeat"></i> Retry Download',
          );
          break;

        case 'download_completed':
          $(this.dom.RJE_INSTALL).html(
            '<i class="icon cloud download"></i> ' +
              $(this.dom.RJE_INSTALL).data('install-text'),
          );
          $(this.dom.RJE_INSTALL)
            .prop('disabled', false)
            .removeClass('disabled');
          break;

        case 'moving_package_failed':
        case 'download_pinpad_failed':
        case 'install_failed':
          $(this.dom.RJE_INSTALL)
            .prop('disabled', false)
            .removeClass('disabled');
          $(this.dom.RJE_INSTALL).text(
            $(this.dom.RJE_INSTALL).data('reinstall-text'),
          );
          break;

        case 'installed':
          $(this.dom.MODIFY_ACTIONS).hide();
          $(this.dom.RJE_ACTIONS).hide();
          this._stopListening();
          break;
      }

      if (!$(this.dom.RJE_INSTALL).hasClass('disabled')) {
        $(this.dom.RJE_INSTALL).prop(
          'title',
          $(this.dom.RJE_INSTALL).data('enabled-help-text'),
        );
      } else if (this.packageStatus.package.status === 'scheduled') {
        $(this.dom.RJE_INSTALL).prop(
          'title',
          $(this.dom.RJE_INSTALL).data('disabled-help-text'),
        );
      }
    },

    _performRjeAction: function (e) {
      var msg, rjeAction, originalPackageStatus;

      e.preventDefault();
      if (
        $(e.target).prop('disabled') ||
        $(e.target).parent().prop('disabled')
      ) {
        return;
      }
      $(e.target).attr('disabled', true).addClass('disabled');

      rjeAction = $(e.currentTarget).data('action');
      originalPackageStatus = this.packageStatus;
      if (rjeAction === 'download') {
        this.packageStatus.package.status = 'downloading';
      } else if (rjeAction === 'install') {
        this.packageStatus.package.status = 'installing';
      }
      this._setStatus(this.packageStatus);

      $.ajax({
        type: 'POST',
        url: $(this.dom.PACKAGE_ID).val() + '/rje',
        data: {
          rje_action: rjeAction,
          authenticity_token: $('meta[name=csrf-token]').attr('content'),
        },
      }).fail(
        function (response) {
          $(e.target).attr('disabled', true);
          this._setStatus(originalPackageStatus);
          try {
            msg = response.responseJSON.error;
          } catch {
            msg = response.statusText;
          }
          $(this.PACKAGE_CONTENTS).prepend(
            "<div id='package-rje-error' class='alert-box ui alert message'><p>" +
              msg +
              '</p></div>',
          );
        }.bind(this),
      );
    },

    _checkStoreImpact: function (e) {
      var values = {},
        self = this,
        proceed;

      if ($(e.target).hasClass('s3-submit-triggered')) {
        $(e.target).removeClass('s3-submit-triggered');
        return true;
      }

      e.preventDefault();

      proceed = function () {
        if ($(self.dom.PACKAGE_UPLOAD)[0].files[0] !== undefined) {
          self.S3Handler.triggerUpload();
        } else {
          $(e.target).addClass('s3-submit-triggered');
          $(e.target).submit();
        }
      };

      // cleanup params by removing empty values from multiple value input and excluding the input method
      values = $(e.target)
        .serializeArray()
        .filter((item) => {
          return item.name.includes('[]')
            ? item.value !== ''
            : item.name != '_method';
        });
      this._warnImpactedStores($.param(values), proceed);
      return false;
    },

    _updateScheduleErrors: function () {
      var errorMsg;

      if (
        $.isEmptyObject($(this.dom.SCHEDULE_TO).val()) ||
        !this._isErrorStatus(this.packageStatus.package.status)
      ) {
        $(this.dom.SCHEDULE_TO).removeClass('schedule-error');
        $(this.dom.SCHEDULE_ERROR_DETAILS).addClass('hidden');
        return;
      }

      $(this.dom.SCHEDULE_TO).addClass('schedule-error');
      $(this.dom.SCHEDULE_ERROR_DETAILS).removeClass('hidden');

      if (this.packageStatus.package.status === 'download_failed') {
        errorMsg =
          'Something bad happened and the package was not downloaded to the target, ' +
          'if the problem is not fixed before the scheduled time, installation will not proceed.';
      } else {
        errorMsg =
          'An error occurred which prevented the scheduled installation time. ' +
          'Please fix the problem and reschedule the install or manually install it when you are ready.';
      }

      $(this.dom.SCHEDULE_ERROR_DETAILS).text(errorMsg);
    },

    _isErrorStatus: function (status) {
      switch (
        status // eslint-disable-line default-case
      ) {
        case 'download_failed':
        case 'download_pinpad_failed':
        case 'moving_package_failed':
          return true;
      }
      return false;
    },

    _warnImpactedStores: function (pkg, proceedCallback) {
      var warnModal;

      warnModal = new IO.Views.Components.ConfirmationDialog({
        url: '/' + currentCustomer + '/package_impacted_stores',
        jst_template: 'packages/impacted_stores', // eslint-disable-line camelcase
      });
      warnModal.impact(pkg);
      warnModal.answer(function (proceed) {
        if (proceed) {
          proceedCallback();
        }
        warnModal.destroy();
      });
    },
  });

  exports.Show = Show;
});
